import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20artistic%20background%20with%20soft%20geometric%20shapes%20and%20flowing%20organic%20forms%2C%20warm%20amber%20and%20coral%20tones%20with%20cream%20highlights%2C%20modern%20minimalist%20design%2C%20smooth%20textures%2C%20creative%20atmosphere%2C%20digital%20art%20style%2C%20no%20text%2C%20abstract%20composition%20with%20rounded%20shapes%20and%20soft%20gradients%2C%20elegant%20and%20warm%20aesthetic&width=1800&height=800&seq=hero-bg-mogutv-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-md rounded-full px-4 py-1.5 mb-6 border border-background-50/30">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">{siteInfo.tagline}</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 font-heading leading-tight">
          蘑菇tv成品人
          <br />
          <span className="text-primary-300">一站式的创作灵感平台</span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚海量精选成品内容资源，为每一位蘑菇tv成品人提供内容发现、
          资源获取与创作灵感的专属频道，让优质内容触手可及。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/latest-recommend"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            探索精选内容
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg backdrop-blur-sm transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-background-50/30"
          >
            了解我们
          </Link>
        </div>

        {/* Stats bar */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: "128,000+", label: "注册创作者" },
            { value: "56,000+", label: "成品资源" },
            { value: "380+", label: "创作教程" },
            { value: "99.7%", label: "用户好评率" },
          ].map((stat) => (
            <div key={stat.label} className="bg-background-50/10 backdrop-blur-sm rounded-xl p-4 border border-background-50/20">
              <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}